import stageKey from "Utils/stageKey";

const DAY = 86400000;
const EMAIL = ["email", "manualemail"];
const CALL = ["phone"];
const LINKEDIN = ["linkedin"];
const BLOCKED = ["OPTED_OUT", "BOUNCED", "DO_NOT_CONTACT"];

const performTaskFindings = ({ taskType = "", linkedInTaskType = "", contactStage = "", lastReplyTs = 0, now = Date.now() } = {}) => {
  const out = [];
  if (!taskType) return out;
  const type = String(taskType).toLowerCase();
  const stage = stageKey(contactStage);
  // A bounce only blocks email; a LinkedIn message or a call still reaches them.
  // Opting out blocks every channel.
  const blocked = stage === "BOUNCED" ? EMAIL.includes(type) : BLOCKED.includes(stage);
  if (blocked) {
    out.push({
      tone: "bad",
      key: "blocked_contact",
      label: stage === "BOUNCED" ? "Email bounced" : "Contact opted out",
      text: stage === "BOUNCED" ? "This will not land. Skip or enrich first." : "They asked not to be contacted. Skip this task."
    });
  }
  if (lastReplyTs && now - lastReplyTs < 7 * DAY) {
    const days = Math.max(1, Math.floor((now - lastReplyTs) / DAY));
    out.push({
      tone: "hot",
      key: "recent_reply",
      label: `Replied ${days} day${days === 1 ? "" : "s"} ago`,
      text: "Read their reply before you act. Answer it, do not send the next step."
    });
  }
  if (EMAIL.includes(type)) {
    out.push({ tone: "neutral", key: "draft_email", label: "Draft this email", text: "I can write it from the thread and what we know about them." });
  } else if (CALL.includes(type)) {
    out.push({ tone: "neutral", key: "call_brief", label: "Pre-call brief", text: "Last touch, what they opened, company news and a suggested opener, in five lines." });
  } else if (LINKEDIN.includes(type) || linkedInTaskType) {
    out.push({ tone: "neutral", key: "linkedin_note", label: "Connection note", text: "Under 300 characters, one reason to connect, no pitch." });
  }
  return out;
};

export default performTaskFindings;
